import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'data-model-prefs',
    templateUrl: './data-model-prefs.component.html',
    styleUrls: ['./data-model-prefs.component.scss'],
    standalone: false
})
export class DataModelPrefsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
